export const MISSION_CONTENT = {
  title: 'Our Mission',
  description:
    'To empower individuals through safe, ethical, and client-centered hypnotherapy, delivered online by highly trained and certified practitioners.',
  commitmentTitle: 'We are committed to:',
  buttonText: 'Explore Our Services',
};

export const COMMITMENTS = [
  'Making hypnotherapy accessible worldwide',
  'Creating safe, confidential, HIPAA-compliant healing environments',
  'Upholding the highest standards of training,\ncertification, and ethics',
  'Supporting personal transformation, growth, and\nself-discovery',
];

